import React, { useEffect, useState } from "react";
import api from "./Axios/api";

const StockSummaryModal = ({ isOpen, onClose, itemId, itemTitle }) => {
    const [stockData, setStockData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isOpen || !itemId) return;

        const getStockSummary = async () => {
            try {
                setLoading(true);
                const res = await api.get(
                    `summary-report/stocks/${itemId}`
                );

                if (res.data.success) {
                    setStockData(res.data.data);
                }
            } catch (error) {
                console.error("Error fetching stock summary:", error);
            } finally {
                setLoading(false);
            }
        };

        getStockSummary();
    }, [isOpen, itemId]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">

            <div className="bg-white rounded-lg shadow-xl w-[800px] max-w-[90%]">

                {/* Header */}
                <div className="flex justify-between items-center px-6 py-4 border-b">

                    <div>
                        <h2 className="text-xl font-bold">
                            Stock Summary
                        </h2>

                        <p className="text-sm text-gray-500">
                            {itemTitle}
                        </p>
                    </div>

                </div>

                {/* Body */}
                <div className="p-6">

                    {loading && (
                        <div className="text-center py-8">
                            Loading...
                        </div>
                    )}

                    {!loading && stockData && (
                      <div className="overflow-x-auto border rounded-lg">
    <table className="w-full text-sm text-left">
        <thead className="bg-gray-100">
            <tr>
                <th className="px-4 py-3 font-semibold text-gray-700">
                    Particular
                </th>
                <th className="px-4 py-3 font-semibold text-gray-700">
                    Value
                </th>
            </tr>
        </thead>

        <tbody>
            <tr className="border-t">
                <td className="px-4 py-3 text-gray-500">
                    Month
                </td>
                <td className="px-4 py-3 font-semibold">
                  {new Date(`${stockData.month}-01`).toLocaleDateString("en-GB", {
        month: "2-digit",
        year: "numeric",
    })}
                </td>
            </tr>

            <tr className="border-t">
                <td className="px-4 py-3 text-gray-500">
                    Opening Balance
                </td>
                <td className="px-4 py-3 font-semibold">
                    {stockData.openingBalance}
                </td>
            </tr>

            <tr className="border-t">
                <td className="px-4 py-3 text-gray-500">
                    Purchase Quantity
                </td>
                <td className="px-4 py-3 font-semibold">
                    {stockData.purchaseQty}
                </td>
            </tr>

            <tr className="border-t">
                <td className="px-4 py-3 text-gray-500">
                    Consume Quantity
                </td>
                <td className="px-4 py-3 font-semibold">
                    {stockData.consumeQty}
                </td>
            </tr>

            <tr className="border-t bg-gray-50">
                <td className="px-4 py-3 font-bold">
                    Closing Balance
                </td>
                <td className="px-4 py-3 text-lg font-bold">
                    {stockData.closingBalance}
                </td>
            </tr>
        </tbody>
    </table>
</div>
                    )}

                    {!loading && !stockData && (
                        <p className="text-center text-gray-500 py-8">
                            No stock data found.
                        </p>
                    )}

                </div>

                {/* Footer */}
                <div className="flex justify-end px-6 py-4 border-t">

                    <button
                        onClick={onClose}
                        className="bg-red-500 text-black px-4 py-2 rounded"
                    >
                        Close
                    </button>

                </div>

            </div>
        </div>
    );
};

export default StockSummaryModal;